import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-consolidated-weather-summary-card',
    templateUrl: './consolidated-weather-summary-card.component.html',
    styleUrls: ['./consolidated-weather-summary-card.component.scss'],
    standalone: false
})
export class ConsolidatedWeatherSummaryCardComponent implements OnInit, OnDestroy {
  @Input() data: any;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor() {
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
